"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const newsFeedSlice_1 = require("../../../../redux/slices/newsFeedSlice");
const deleteComment = (props) => {
    const { newsFeed } = props;
    // delete message
    const deleteComment = (status) => {
        props.delComment(status);
    };
    return (react_1.default.createElement(core_1.Dialog, { open: newsFeed.deleteModalOpen, onClose: () => {
            props.toggleModal();
        }, fullWidth: true, maxWidth: 'sm', className: 'v2-modal-container' },
        react_1.default.createElement("p", { className: "text" }, "Are you sure you want to delete this comment?"),
        react_1.default.createElement(core_1.Box, { display: 'flex', justifyContent: 'flex-end', className: 'btn-wrapper' },
            react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-danger', onClick: () => {
                    props.toggleDeleteCommentModal();
                    deleteComment(true);
                } }, "Delete"),
            react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-tertiary', onClick: () => {
                    props.toggleModal();
                } }, "Never Mind"))));
};
const mapStateToProps = (state) => {
    const { newsFeed } = state;
    return {
        newsFeed
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        delComment: (status) => dispatch(newsFeedSlice_1.delComment(status)),
        toggleDeleteCommentModal: () => dispatch(newsFeedSlice_1.toggleDeleteCommentModal()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(deleteComment);
